export const stringifyObject = (a: Record<string, string | number>) =>
  Object.entries(a).sort().toString();
